module.exports = __webpack_public_path__ + "static/media/foodSurvey.7e105610.png";